import axios from "axios";
import { getToken } from "../../../../common/environment_config.es6";
import { getMwRoot } from "./mwRoot";

// Lives in ./mwRoot (no axios there); re-exported for the existing importers.
export { getMwRoot };

const api = axios.create({
  withCredentials: true,
});
api.interceptors.request.use((config) => {
  config.baseURL = `${getMwRoot()}/api/jobs`;
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export default api;
